export const CLASS_TOPBAR_COLLABORATORS = 'topbar__collaborators';
